/**
 * TÄLU · Components inyectables
 * - Sección "Recomendados" al final de cada página
 * - Botón "Agregar al carrito" en PDPs producto
 * - Contador del carrito en nav
 *
 * Uso: <script src="../scripts/components.js" defer></script>
 *      Configurar data attributes en <body>:
 *        data-page-id="raw" (id de la página actual, para excluirla del recomendados)
 *        data-product-handle="talu-raw" (handle Shopify, opcional para add-to-cart)
 *        data-product-variant="49080..." (variant id Shopify, opcional)
 *        data-product-price="19990" (precio del producto, opcional)
 */
(function () {
  'use strict';

  // Catálogo TÄLU completo (handle → metadata)
  // Imágenes oficiales Shopify CDN
  const CATALOG = {
    'raw': {
      title: 'TÄLU RÄW',
      tag: 'Skincare',
      price: 19990,
      url: 'raw.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/RAW1.png?v=1764100575',
      sectionRel: 'skincare',
    },
    'clear': {
      title: 'TÄLU CLEAR',
      tag: 'Skincare · Acné',
      price: 21900,
      url: 'clear.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/image_6b1d8b8b-014d-425b-a8c0-150b73b1b87e.png?v=1772602568',
      sectionRel: 'skincare',
    },
    'premium': {
      title: 'TÄLU PREMIUM',
      tag: 'Antiedad · Noche',
      price: 24990,
      url: 'premium.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/PREMIUM11.png?v=1764100648',
      sectionRel: 'skincare',
    },
    'tallow-res': {
      title: 'TALLOW Res',
      tag: 'Cocina · 410ml',
      price: 11990,
      url: 'tallow-res.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/image_a232df3a-fcd2-4a82-8e4a-64ffbcab3c94.png?v=1776195409',
      sectionRel: 'cocina',
    },
    'tallow-ternero': {
      title: 'TALLOW Ternero',
      tag: 'Cocina · más fino',
      price: 13990,
      url: 'tallow-ternero.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/hf_20260421_225806_ddfd11bb-836b-4079-9bec-c47b123ed94f.png?v=1777068092',
      sectionRel: 'cocina',
    },
    'pack-cocina': {
      title: 'Pack Cocina Ancestral',
      tag: 'Pack · Ahorra 19%',
      price: 20990,
      compareAt: 23980,
      url: 'pack-cocina-ancestral.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/pack_cocina_ancestral.png?v=1776378068',
      sectionRel: 'pack',
    },
    'pack-rutina': {
      title: 'Pack Rutina Skincare',
      tag: 'Pack · Ahorra 23%',
      price: 50990,
      compareAt: 64880,
      url: 'pack-rutina-skincare.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/pack_skincare_completa.png?v=1776378071',
      sectionRel: 'pack',
    },
    'pack-familia': {
      title: 'Pack Familia',
      tag: 'Pack · Ahorra 30%',
      price: 69990,
      compareAt: 97850,
      url: 'pack-familia.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/pack_familia_completo.png?v=1776378074',
      sectionRel: 'pack',
    },
    'pack-dia-madre': {
      title: 'Pack Día de la Madre',
      tag: 'Edición Limitada',
      price: 25990,
      compareAt: 29980,
      url: 'pack-dia-madre.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/IMG-1981.png?v=1777999414',
      sectionRel: 'pack',
    },
    'ternero': {
      title: 'El Ternero TÄLU',
      tag: 'Manifesto · Origen',
      price: null,
      url: 'ternero.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/hf_20260421_225806_ddfd11bb-836b-4079-9bec-c47b123ed94f.png?v=1777068092',
      sectionRel: 'manifesto',
    },
    'gift-card': {
      title: 'Tarjeta de Regalo',
      tag: 'Desde $20.000',
      price: null,
      url: 'gift-card.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/gift_card_20000.png?v=1776375766',
      sectionRel: 'gift',
    },
    'wow-rm': {
      title: 'Reprogramación Metabólica',
      tag: 'WOW · Solo miembros',
      price: 20990,
      compareAt: 25980,
      url: 'reprogramacion-metabolica.html',
      img: 'https://cdn.shopify.com/s/files/1/0778/1679/1279/files/convenio-talu-1.png?v=1776874150',
      sectionRel: 'wow',
    },
  };

  // ========== Recomendados por página actual ==========
  // Reglas: skincare → otras skincare + 1 cocina. Cocina → otras cocina + 1 skincare.
  // Pack → 2 productos individuales del catálogo y 1 otro pack.
  // Always recommend Pack Familia + Pack Día Madre cuando aplique.
  function getRecommendations(currentId) {
    const map = {
      'raw': ['clear', 'premium', 'pack-rutina', 'pack-familia'],
      'clear': ['raw', 'premium', 'pack-rutina', 'pack-familia'],
      'premium': ['raw', 'clear', 'pack-rutina', 'pack-familia'],
      'tallow-res': ['tallow-ternero', 'pack-cocina', 'pack-familia', 'raw'],
      'tallow-ternero': ['tallow-res', 'pack-cocina', 'pack-familia', 'premium'],
      'pack-cocina': ['tallow-res', 'tallow-ternero', 'pack-rutina', 'pack-familia'],
      'pack-rutina': ['raw', 'clear', 'premium', 'pack-familia'],
      'pack-familia': ['pack-rutina', 'pack-cocina', 'pack-dia-madre', 'gift-card'],
      'pack-dia-madre': ['pack-familia', 'pack-rutina', 'pack-cocina', 'gift-card'],
      'wow-rm': ['tallow-ternero', 'tallow-res', 'pack-familia', 'pack-dia-madre'],
      'ternero': ['raw', 'premium', 'tallow-ternero', 'pack-familia'],
      'gift-card': ['pack-familia', 'pack-rutina', 'pack-cocina', 'pack-dia-madre'],
      'contacto': ['raw', 'tallow-res', 'pack-familia', 'gift-card'],
      'home': ['pack-familia', 'pack-rutina', 'pack-dia-madre', 'gift-card'],
    };
    return (map[currentId] || ['raw', 'pack-familia', 'tallow-res', 'gift-card']).slice(0, 4);
  }

  function formatCLP(n) {
    return '$' + Number(n).toLocaleString('es-CL');
  }

  function buildRecommendedHTML(currentId) {
    const ids = getRecommendations(currentId);
    const cards = ids.map(id => {
      const item = CATALOG[id];
      if (!item) return '';
      const priceBlock = item.price
        ? `<div class="rec-price">${item.compareAt ? `<span class="was">${formatCLP(item.compareAt)}</span>` : ''}${formatCLP(item.price)}</div>`
        : '';
      return `
        <a href="${item.url}" class="rec-card">
          <div class="rec-img"><img src="${item.img}" alt="${item.title}" loading="lazy"></div>
          <div class="rec-body">
            <div class="rec-tag">${item.tag}</div>
            <h3>${item.title}</h3>
            ${priceBlock}
          </div>
        </a>`;
    }).join('');

    return `
      <section class="recommended">
        <div class="rec-header">
          <span class="rec-eyebrow">También te puede interesar</span>
          <h2>Otros <em>rituales</em> TÄLU</h2>
        </div>
        <div class="rec-grid">
          ${cards}
        </div>
      </section>`;
  }

  // ========== Insertar sección Recomendados antes del footer ==========
  // NOTA: el home (data-page-id="home") está EXCLUIDO de recomendados
  // por decisión de Diego — el catálogo del home ya cumple esa función.
  const PAGES_WITHOUT_RECOMMENDED = ['home'];

  function injectRecommended() {
    const currentId = document.body.dataset.pageId;
    if (!currentId) return; // No data-page-id → skip
    if (PAGES_WITHOUT_RECOMMENDED.includes(currentId)) return; // Excluida
    if (document.querySelector('.recommended')) return; // Already exists

    const html = buildRecommendedHTML(currentId);
    const footer = document.querySelector('footer.footer, footer.footer-mom, footer');
    if (footer) {
      footer.insertAdjacentHTML('beforebegin', html);
    } else {
      document.body.insertAdjacentHTML('beforeend', html);
    }
  }

  // ========== Botón Agregar al carrito flotante (PDPs producto) ==========
  function injectAddToCart() {
    const handle = document.body.dataset.productHandle;
    if (!handle) return;
    if (document.querySelector('.btn-add-cart-floating')) return;

    const variantId = document.body.dataset.productVariant || '';
    const cartUrl = variantId
      ? `https://www.taluchile.cl/cart/${variantId}:1`
      : `https://www.taluchile.cl/products/${handle}`;

    // Insertar 1 botón add-to-cart cerca del CTA principal de la página
    // Buscamos el primer botón con .btn-primary y añadimos uno después
    const primaryBtn = document.querySelector('.hero-cta-row .btn-primary, .price-card .btn-primary');
    if (!primaryBtn) return;

    const addBtn = document.createElement('a');
    addBtn.href = cartUrl;
    addBtn.target = '_blank';
    addBtn.rel = 'noopener';
    addBtn.className = 'btn-add-cart';
    addBtn.dataset.action = 'add-to-cart';
    addBtn.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
        <path d="M5 8h14l-1.4 9.5a2 2 0 0 1-2 1.7H8.4a2 2 0 0 1-2-1.7L5 8z"/>
        <path d="M9 8V6a3 3 0 0 1 6 0v2"/>
        <path d="M12 13v3M10.5 14.5h3" stroke-linecap="round"/>
      </svg>
      Agregar al carrito
    `;

    // Animación cart al click + bump al nav-cart
    addBtn.addEventListener('click', (e) => {
      const navCart = document.querySelector('.nav-cart');
      if (navCart) {
        navCart.classList.remove('is-animating');
        // force reflow
        void navCart.offsetWidth;
        navCart.classList.add('is-animating');
        setTimeout(() => navCart.classList.remove('is-animating'), 700);

        // increment count
        let badge = navCart.querySelector('.cart-count');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count visible';
          badge.textContent = '1';
          navCart.appendChild(badge);
        } else {
          const cur = parseInt(badge.textContent || '0', 10);
          badge.textContent = cur + 1;
          badge.classList.add('visible');
        }
      }
    });

    // Insertar después del primary button
    primaryBtn.parentElement.insertBefore(addBtn, primaryBtn.nextSibling);
  }

  // ========== INIT ==========
  function init() {
    injectRecommended();
    injectAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
